import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetMasterBadge {}

export const getMasterQuestionEvaluation = () => {
  return HttpService.get(
    `${ApiService.icdc.module.selfReport.getQuestionEvaluation}`
  );
};

export const getListFacilitator = () => {
  return HttpService.post(ApiService.icdc.module.selfReport.getFacilitator, {
    keyword: '',
    sortColumn: '',
    sortOrder: '',
    page: 1,
    take: 100000
  });
};

export const postEvaluation = (data) => {
  return HttpService.post(
    ApiService.icdc.module.selfReport.postEvaluation,
    data
  );
};

export const updateEvaluation = (data) => {
  return HttpService.post(
    ApiService.icdc.module.selfReport.updateEvaluation,
    data
  );
};

export const detailEvaluation = (data) => {
  return HttpService.post(
    ApiService.icdc.module.selfReport.detailReviewEvaluation,
    data
  );
};

export const approve = (data) => {
  return HttpService.post(
    ApiService.icdc.module.selfReport.approveReviewEvaluation,
    data
  );
};

export const reject = (data) => {
  return HttpService.post(
    ApiService.icdc.module.selfReport.rejectReviewEvaluation,
    data
  );
};
